import * as sitemap from './sitemap';
import * as sitemapFile from './sitemap-file';
import * as robots from './robots-txt';
import * as llms from './llms';

const { pattern: sitemapPattern, handler: sitemapHandler } = sitemap;
const { pattern: sitemapFilePattern, handler: sitemapFileHandler } = sitemapFile;
const { pattern: robotsTxtPattern, handler: robotsTxtHandler } = robots;
const { pattern: llmsPattern, handler: llmsTxtHandler } = llms;

const config = new Map();
config.set(sitemapPattern, sitemapHandler);
config.set(sitemapFilePattern, sitemapFileHandler);
config.set(robotsTxtPattern, robotsTxtHandler);
config.set(llmsPattern, llmsTxtHandler);

export default config;
